import { getI18n } from 'react-i18next';

import { Role } from '../enums';
import { IAccount, IOrganizationUser } from '../interfaces';

export const isAdmin = (user?: IOrganizationUser | IAccount) => {
  return user?.roles.includes(Role.ADMIN);
};

export const getUserName = (user?: IOrganizationUser | IAccount) => {
  return `${user?.firstName} ${user?.lastName}`;
};

export const parseUserRoles = (user?: IOrganizationUser | IAccount) => {
  const i18n = getI18n();
  return i18n.t(`common.role.${isAdmin(user) ? Role.ADMIN : Role.USER}`);
};
